import React, { useEffect, useRef } from "react";
import AnalysisInsightCards from "./analysis-insights-details";
import { Box, Typography } from "@mui/material";
import { useAtomValue } from "jotai";
import { baseAtom } from "../../../stores/jotai/base";

export interface InsightGroup {
  title: string;
  description: string;
  insights: string[];
  strategicImplication?: string;
  suggestedReframe?: string;
  parentInsightID?:string;
}

interface AnalysisInsightsProps {
  explicit: InsightGroup[];
  implicit: InsightGroup[];
  meta: InsightGroup[];
}

const insightSections = [
  { key: "explicit", title: "Explicit Insights" },
  { key: "implicit", title: "Implicit Insights" },
  { key: "meta", title: "Thematic Analysis" },
];

const renderInsightSectionTitle = (
  title: string,
  variant: "h5" | "subtitle1" = "subtitle1",
  sx: object = {}
) => (
  <Typography
    variant={variant}
    component={variant === "h5" ? "h2" : "h4"}
    gutterBottom
    sx={{
      ...sx,
    }}
  >
    {title}
  </Typography>
);

export default function AnalysisInsights(props) {
  const { metaArtifactData = {} } = props;

  const { explicit = [], implicit = [], meta = [] } = metaArtifactData;

  const allSections = { explicit, implicit, meta };

  const base = useAtomValue(baseAtom);
  const matchingRef = useRef<HTMLDivElement | null>(null);
  const selectedFindingID = base?.selectedFinding?.findingID;

  // useEffect(() => {
  //   if (matchingRef.current) {
  //     matchingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }
  // }, [selectedFindingID]);

  function findScrollParent(el: HTMLElement): HTMLElement {
    let parent = el.parentElement;
    while (parent) {
      const overflowY = window.getComputedStyle(parent).overflowY;
      if (overflowY === "auto" || overflowY === "scroll") {
        return parent;
      }
      parent = parent.parentElement;
    }
    return document.documentElement; 
  }


  useEffect(() => {
    const el = matchingRef.current;
    if (!el) return;

    const offset = 10; 
    const scrollContainer = findScrollParent(el);
    
    const elementTop = el.getBoundingClientRect().top;
    const containerTop = scrollContainer.getBoundingClientRect().top;

    const scrollTop = scrollContainer.scrollTop;
    const targetScroll = elementTop - containerTop + scrollTop - offset;

    scrollContainer.scrollTo({ top: targetScroll, behavior: "smooth" });
  }, [selectedFindingID]);

  const renderCard = (item, index, type) => {
    const ref = (item.insights.includes(selectedFindingID) || item?.parentInsightID===selectedFindingID) ? matchingRef : null;
    return (
      <AnalysisInsightCards
        key={`${type}-${index}`}
        item={item}
        scrollRef={ref}
        isSelectable={true}
        headingStyle={{
          fontSize:"15px",
        }}
      />
    );
  };


  return (
    <Box sx={{ mt: 3 }}>
      {renderInsightSectionTitle("Key Insights At a Glance", "h5", { fontWeight: 500,fontSize: "20px"})}

      {insightSections.map(({ key, title }) => {
        const items = allSections[key];
        if (!items?.length) return null;

        return (
          <Box key={key} sx={{ mt: 3 }}>
            {renderInsightSectionTitle(title, "subtitle1")}
            {items.map((item, index) => renderCard(item, index, key))}
          </Box>
        );
      })}
    </Box>
  );
}
